import { StudentStore } from '../../../store/models/Store';
import { getItemByIdSelector, getItemByIdTypedSelector } from '../../../store/reducers/items/itemsSelectors';
import { getCurrentItem } from '../../../store/selectors/getCurrentItem';
import { evaluateItemSelector, isItemCompletedSelector } from '../../tracking/services/CompletionService';
import { ensureIsItem, isMenuItem, TrackingStatusEnum } from '@ael/core-api';
import { List } from 'immutable';
import { createSelector } from 'reselect';

interface SubmenuGroup {
  parent: string;
  isExpanded: boolean;
  isActive: boolean;
  childItems: List<string>;
  completedChildItems: number;
  completableChildItems: number;
}

const getSelectedMenuItems: (store: StudentStore) => List<string> = (state: StudentStore) =>
  state.selectedMenuItems.selectedItems;

export const getSubmenuGroupSelector = createSelector(
  [
    getItemByIdTypedSelector,
    getSelectedMenuItems,
    getCurrentItem,
    isItemCompletedSelector,
    evaluateItemSelector,
    getItemByIdSelector,
  ],
  (getItemByIdTypedSelector, selectedItems, currentItem, isItemCompleted, evaluateItem, getItemById) =>
    (itemId: string) => {
      const item = getItemByIdTypedSelector(itemId, isMenuItem);

      const submenuGroup: SubmenuGroup = {
        parent: item.id,
        isExpanded: selectedItems.contains(item.id),
        isActive: selectedItems.last() === item.id && currentItem === null,
        childItems: item.childItems,
        completedChildItems: item.childItems.count((itemId: string) => {
          const item = getItemById(itemId);
          ensureIsItem(item);
          const isCompleted = isItemCompleted(item);

          return isCompleted;
        }),
        completableChildItems: item.childItems.count((itemId: string) => {
          const item = getItemById(itemId);
          ensureIsItem(item);
          const status = evaluateItem(item);
          return status !== TrackingStatusEnum.NotTracked;
        }),
      };

      return submenuGroup;
    }
);
